<template>
  <div class="qw-disdetail">
    <van-skeleton
      v-if="!firstloading"
      title
      :row="5"
      style="background-color:#fff;padding:20px"
    />
    <div v-else class="form-body">
      <div class="form-row">
        <div class="form-row-title">
          {{ GetDescInfo.namelable }}<span class="small"></span>
        </div>
        <van-field
          v-model="dis.channel_name"
          :placeholder="'请输入' + GetDescInfo.namelable"
          border
        />
      </div>
      <div class="form-row">
        <div class="form-row-title">
          {{ GetDescInfo.useuser }}
          <span class="small">{{ GetDescInfo.useuserdesc }}</span>
        </div>
        <van-field
          v-if="useuser.loading"
          :placeholder="'请' + GetDescInfo.useuser"
          readonly
          clickable
          @click="seluseuserEvent"
          :value="getUserName"
        />
        <div class="loading-field" v-else>
          加载中...
          <van-loading />
        </div>
      </div>
      <div class="form-row" v-if="!isdefault">
        <div class="form-row-title">
          自动通过好友<span class="small"
            >开启后，客户通过此二维码扫码加您好友无需您同意</span
          >
        </div>
        <van-switch v-model="dis.auto_firend" />
      </div>
      <div class="form-row" v-if="!isdefault">
        <div class="form-row-title">自动打招呼<span class="small"></span></div>
        <van-switch v-model="dis.auto_sayhi" />
      </div>
      <div class="form-row" v-if="dis.auto_sayhi && channeltype == 1">
        <div class="form-row-title">
          打招呼方式
          <span class="small"></span>
        </div>
        <van-radio-group v-model="dis.hi_content.sendtype">
          <van-radio name="1">采取默认回复的欢迎语</van-radio>
          <van-radio name="0">自定义欢迎语</van-radio>
        </van-radio-group>
      </div>
      <template
        v-if="
          !dis.hi_content.sendtype ||
            dis.hi_content.sendtype == 0 ||
            channeltype != 1
        "
      >
        <div class="form-row" v-if="dis.auto_sayhi">
          <div class="form-warning">
            <img src="../../static/images/icon/icon-warning-h.png" alt />
            因企业微信限制，若您的企业已经在"企业微信后台"配置了欢迎语，这里的打招呼将不会生效
            <a
              href="javascript:void(0);"
              @click="preview(require('../../static/images/help-autohi.png'))"
              >查看解释</a
            >
          </div>
          <div class="form-row-title">
            打招呼内容<span class="small"></span>
          </div>
          <van-tabs
            v-model="hi_content_tab"
            style="border:1px solid #ebedf0; background-color:#fafafa"
          >
            <van-tab title="文字" name="a" class="pd15">
              <div class="form-row">
                <div class="form-row-title">
                  文本内容<span class="small"></span>
                </div>
                <hitext v-model="dis.hi_content.text.content"></hitext>
                <!-- <van-field v-model="dis.hi_content.text.content" rows="3" type="textarea" maxlength="500"
                placeholder="请输入打招呼的内容" show-word-limit border /> -->
              </div>
            </van-tab>
            <van-tab title="文字+图片" name="b" class="pd15">
              <div class="form-row">
                <div class="form-row-title">
                  文本内容<span class="small">若不输入，则只回复图片</span>
                </div>
                <hitext v-model="dis.hi_content.text.content"></hitext>
                <!-- <van-field v-model="dis.hi_content.text.content" rows="3" type="textarea" maxlength="500"
                placeholder="请输入打招呼的内容" show-word-limit border /> -->
              </div>
              <div class="form-row">
                <div class="form-row-title">
                  图片内容<span class="small"></span>
                </div>
                <van-uploader
                  name="imager_vantuploader"
                  @click-preview="clickpreview"
                  :before-read="beforeRead"
                  :after-read="afterRead"
                  v-model="image_vant"
                  :preview-full-image="false"
                  :max-count="1"
                />
              </div>
            </van-tab>

            <van-tab title="文字+海报" name="d" class="pd15">
              <!-- <div class="form-row-center" v-if="firminfo == null">
              <van-loading />
            </div>
            <template v-else>
              <div class="form-row" v-if="firmversion != '基础版'">
                你现在的版本不能使用海报功能，<a href="javascript:void(0)">点击升级</a>
              </div>
              <template v-else> -->
              <div class="form-row">
                <div class="form-row-title">
                  文本内容<span class="small">若不输入，则只回复图片</span>
                </div>
                <hitext v-model="dis.hi_content.text.content"></hitext>
              </div>
              <div class="form-row">
                <div class="form-row-title">
                  海报内容<span class="small"></span>
                </div>
                <div
                  class="poster-add"
                  @click="poseter_module"
                  v-if="!posterupload_result"
                >
                  <van-icon name="plus" />
                </div>
                <van-image
                  class="poster-image"
                  @click="poseter_module"
                  width="80"
                  fit="cover"
                  height="80"
                  :src="
                    imghost +
                      posterupload_result.poster_link +
                      '?imageMogr2/thumbnail/250x/interlace/0'
                  "
                  v-else
                />
              </div>
              <!-- </template>
            </template> -->
            </van-tab>

            <van-tab title="文字+图文链接" name="c" class="pd15">
              <div class="form-row">
                <div class="form-row-title">
                  文本内容<span class="small">若不输入，则只回复图文链接</span>
                </div>
                <hitext v-model="dis.hi_content.text.content"></hitext>
                <!-- <van-field v-model="dis.hi_content.text.content" rows="3" type="textarea" maxlength="500"
                placeholder="请输入打招呼的内容" show-word-limit border /> -->
              </div>
              <div class="form-row">
                <div class="form-row-title">
                  图文链接标题<span class="small"></span>
                </div>
                <hitext
                  v-model="dis.hi_content.link.title"
                  :height="45"
                ></hitext>
                <!-- <van-field v-model="dis.hi_content.link.title" placeholder="请输入链接标题" border /> -->
              </div>
              <div class="form-row">
                <div class="form-row-title">
                  图文链接描述<span class="small"></span>
                </div>
                <hitext
                  v-model="dis.hi_content.link.desc"
                  :height="70"
                ></hitext>
                <!-- <van-field v-model="dis.hi_content.link.desc" placeholder="请输入图文链接描述" border /> -->
              </div>
              <div class="form-row">
                <div class="form-row-title">
                  图文链接小图标<span class="small"></span>
                </div>
                <van-uploader
                  name="link_vantuploader"
                  :before-read="beforeRead"
                  :preview-full-image="false"
                  :after-read="afterRead"
                  :max-count="1"
                  @click-preview="clickpreview"
                  v-model="link_vant"
                />
              </div>
              <div class="form-row">
                <div class="form-row-title">
                  图文链接地址<span class="small"></span>
                </div>
                <van-field
                  v-model="dis.hi_content.link.url"
                  placeholder="请输入图文链接地址"
                  border
                />
              </div>
            </van-tab>
          </van-tabs>
        </div>
      </template>
      <div class="form-row">
        <div class="form-row-title">自动打标签<span class="small"></span></div>
        <van-switch v-model="dis.auto_tab" />
      </div>
      <div class="form-row" v-if="dis.auto_tab">
        <div class="form-row-title">标签内容<span class="small"></span></div>
        <van-field
          readonly
          clickable
          :value="getTabName"
          placeholder="点击选择标签内容"
          @click="userTabs_sel = true"
        />
      </div>
      <van-button
        type="info"
        :loading="loading_qrc"
        loading-text="数据提交中..."
        block
        style="margin-top:20px"
        @click="DownLoadQrCode"
        v-if="!isdefault"
        >保存并下载二维码</van-button
      >
      <van-button
        type="primary"
        block
        style="margin-top:15px"
        @click="SubData"
        :loading="loading_sub"
        loading-text="数据提交中..."
        >{{ GetDescInfo.btnsublable }}</van-button
      >
    </div>
    <van-popup
      v-model="userTabs_sel"
      position="bottom"
      :style="{ height: '70%' }"
    >
      <wx_tags :userTabs="userTabs" v-if="userTabs_sel"></wx_tags>
    </van-popup>
    <van-popup
      v-model="useuser_sel"
      position="bottom"
      :style="{ height: '70%' }"
    >
      <wx_users :useuser="useuser" v-if="useuser_sel && !hasdept"></wx_users>
      <wx_usersn :useuser="useuser" v-if="useuser_sel && hasdept"></wx_usersn>
    </van-popup>

    <van-popup v-model="posterupload_show" position="bottom">
      <div class="popup-menu">
        <div class="popup-menu-content"></div>
        <a
          href="javascript:void(0);"
          class="fright cancel"
          @click="posterupload_show = false"
          >取消</a
        >
      </div>
      <wx_poster
        @callback="poster_module_enter"
        v-if="posterupload_show"
      ></wx_poster>
    </van-popup>
    <!-- <van-popup
      v-model="useuser_sel"
      position="bottom"
      :style="{ height: '40%' }"
    >
      <van-picker
        show-toolbar
        :columns="useuser_data"
        @cancel="useuser_sel = false"
        @confirm="useuser_sel_confirm"
      />
    </van-popup> -->
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import hitext from "../components/hitext";
import config from "@/config";
import wx_tags from "./Tags";
import wx_usersn from "./SelUserN";
import wx_users from "./SelUser";
import Vue from "vue";
import { newname } from "@/util/crypto";
import { ImagePreview } from "vant";
import wx_poster from "./poster/posteredit";
import ptypes from "../producttype";
import {
  Button,
  Field,
  Switch,
  Picker,
  Popup,
  Tabs,
  Tab,
  Panel,
  Uploader,
  Toast,
  Skeleton,
  Dialog,
} from "vant";
Vue.use(Button);
Vue.use(Field);
Vue.use(Switch);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(Tabs);
Vue.use(Tab);
Vue.use(Panel);
Vue.use(Uploader);
Vue.use(Toast);
Vue.use(Skeleton);
Vue.use(Dialog);
export default {
  name: "qd-disdetail",
  data() {
    return {
      firstloading: false,
      dis: {
        channel_name: "",
        auto_firend: 1,
        auto_sayhi: 1,
        useuser: "",
        tab_content: [],
        hi_content: {
          sendtype: "1",
          text: {
            content: "",
          },
          image: {
            media_path: "",
          },
          link: {
            title: "",
            picurl: "",
            desc: "",
            url: "",
          },
        },
        auto_tab: 1,
      },
      //图文消息图片
      image_vant: [],
      //图文链接图片
      link_vant: [],
      //显示使用人下拉框
      useuser_sel: false,
      useuser_data: [],
      useuser: {
        datas: [],
        seldatas: [],
        closeModal: function() {},
        loading: false,
      },
      //打招呼方式
      hi_content_tab: "a",
      //标签相关
      userTabs: {
        seltag: [],
        datas: [],
        confimEvent: function() {},
      },

      userTabs_sel: false,
      //渠道ID
      channelid: 0,
      isdefault: false,
      loading_sub: false,
      loading_qrc: false,
      channeltype: 0,

      hasdept: false,

      //海报上传界面是否显示
      posterupload_show: false,
      posterupload_result: null,
      posterupload_wait: null,
      posterupload_loading: false,

      imghost: config.img_host,
    };
  },
  methods: {
    //打开海报上传的窗体
    async poseter_module() {
      var firmVersion = await this.GetFirmVersionAsync();
      if (firmVersion == "基础版") {
        this.$AskBuy("基础版无法使用该模块，请先升级您的版本");
        return;
      }
      if (this.posterupload_result) {
        console.log("has poster info");
        localStorage.setItem(
          "poster.config",
          JSON.stringify(this.posterupload_result)
        );
      } else {
        console.log("no poster info");
        localStorage.removeItem("poster.config");
      }
      this.posterupload_show = true;
    },
    poster_module_enter(res) {
      this.posterupload_result = res;
      this.posterupload_show = false;
      console.log("posterupload_result", this.posterupload_result);
    },
    //打开海报上传的窗体
    poseter_go() {
      this.posterupload_wait = this.posterupload_result;
      this.posterupload_show = true;
    },
    //取消上传海报
    poster_cancel() {
      this.posterupload_show = false;
    },
    //确认上传海报
    poster_enter() {
      if (
        this.posterupload_wait &&
        this.posterupload_wait.length > 0 &&
        !this.posterupload_wait[0].status
      ) {
        this.posterupload_result = this.posterupload_wait;
        this.posterupload_show = false;
      } else {
        this.$Toast("还没上传海报哦");
      }

      console.log("posterupload_result", posterupload_result);
    },
    //获得部门下的所有部门
    getDeptObj(deptid) {
      var t = this;

      deptid = deptid || 1;
      this.$http
        .get("/Firm/GetDeptObj", { deptid: deptid || 1 }, 2)
        .then((res) => {
          if (res.resultState == 1) {
            t.hasdept = true;
          }
        })
        .catch((error) => {});
    },
    preview(url) {
      ImagePreview({
        images: [url],
        closeable: true,
        closeOnPopstate: true,
      });
    },
    clickpreview(e) {
      ImagePreview({
        images: [e.url],
        closeable: true,
        closeOnPopstate: true,
      });
      console.log("clickpreview", e);
    },
    closepreview() {
      console.log("closepreview");
    },
    //图片过大
    overSize(e) {
      console.log("overSize", overSize);
    },
    //图片格式校验
    beforeRead(file) {
      console.log("beforeRead", file);
      if (file.size > 4 * 1024 * 1024) {
        Toast("图片大小不能超过4M");
        return false;
      }
      if (file.type.indexOf("image") < 0) {
        Toast("只能上传图片格式");
        return false;
      }
      return true;
    },
    //上传图片
    afterRead(file_obj, detail) {
      var t = this;
      var file = file_obj.file;
      //设置加载状态
      file_obj.status = "uploading";
      //更换一个随机名称
      var suffix = ".jpg";
      if (file.name.lastIndexOf(".") >= 0)
        suffix = file.name.substr(file.name.lastIndexOf("."));
      var filename = `${newname()}${suffix}`;
      //开始上传
      t.cos_upload(
        //文件保存的路径和名称
        `/${filename}`,
        //文件内容
        file,
        //上传成功后回调函数
        function(err, res) {
          console.log("upload res:", res);
          console.log("upload err:", err);
          if (err) {
            file_obj.status = "failed";
            file_obj.message = "上传失败";
          } else {
            file_obj.status = "";
            file_obj.url = res.Location;
            file_obj.path = res.path;
            // if(detail.name=="imager_vantuploader") t.dis.hi_content.image.media_path = res.Location;
            // else t.dis.hi_content.link.picurl = res.Location;
          }
        },
        //上传进度更新函数
        function(res) {
          console.log("当前进度：", res);
        }
      );
    },

    //点击选择使用人
    seluseuserEvent() {
      this.useuser_sel = true;
      this.useuser.isdefault = this.isdefault;
    },
    //确认选择使用人
    useuser_sel_confirm(value) {
      var t = this;
      t.useuser_sel = false;
      t.dis.useuser = value;
    },
    //获得拥有外部联系权限的用户信息
    GetFollowUserList() {
      var t = this;
      var useuser_data = [];
      this.$http
        .get("/Channel/GetFollowUserInfoList", {}, 2)
        .then((res) => {
          t.useuser.loading = true;
          if (res.resultState == 1) {
            // useuser_data = useuser_data.concat(res.Data);
            // t.useuser_data = useuser_data;
            t.useuser.datas = res.Data;
          }
        })
        .catch((error) => {});
    },
    //获得渠道信息
    GetChannelDetail() {
      var t = this;
      this.$http
        .get("/Channel/GetChannelDetail", { channelid: t.channelid }, 2)
        .then((res) => {
          t.firstloading = true;
          console.log("res", JSON.stringify(res));
          if (res.resultState == 1) {
            var has_img = 1;
            var has_link = 1;
            var dis = res.Data;
            dis.hi_content = JSON.parse(dis.hi_content);
            if (!dis.hi_content.text) dis.hi_content.text = { content: "" };
            else {
              try {
                dis.hi_content.text.content = decodeURIComponent(
                  dis.hi_content.text.content || ""
                );
              } catch (error) {}
            }

            if (!dis.hi_content.image) {
              has_img = 0;
              dis.hi_content.image = {
                media_path: "",
              };
            }
            if (!dis.hi_content.link) {
              has_link = 0;
              dis.hi_content.link = {
                title: "",
                picurl: "",
                desc: "",
                url: "",
                default: 1,
              };
            } else {
              try {
                dis.hi_content.link.title = decodeURIComponent(
                  dis.hi_content.link.title || ""
                );
                dis.hi_content.link.desc = decodeURIComponent(
                  dis.hi_content.link.desc || ""
                );
              } catch (error) {}
            }
            if (dis.hi_content.poster) {
              t.hi_content_tab = "d";
              t.posterupload_result = dis.hi_content.poster;
            }
            if (has_img == 1) {
              t.hi_content_tab = "b";
              t.image_vant = [
                {
                  url: `${config.img_host}${dis.hi_content.image.media_path}`,
                  status: "",
                  message: "",
                  path: dis.hi_content.image.media_path,
                },
              ];
            }
            if (has_link == 1) {
              t.hi_content_tab = "c";
              t.link_vant = [
                {
                  url: `${config.img_host}${dis.hi_content.link.picurl}`,
                  status: "",
                  message: "",
                  path: dis.hi_content.link.picurl,
                },
              ];
            }
            if (!dis.hi_content.sendtype && t.channeltype == 1)
              dis.hi_content.sendtype = dis.channelid > 0 ? 0 : 1;
            dis.hi_content.sendtype = dis.hi_content.sendtype.toString();
            dis.tab_content = JSON.parse(dis.tab_content);

            t.useuser.seldatas = JSON.parse(dis.useuser || "[]");
            t.userTabs.seltag = dis.tab_content;

            if (t.isdefault) dis.auto_sayhi = true;
            if (dis.channelid <= 0) dis.auto_sayhi = true;

            t.dis = dis;
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    //获得企业外部联系人所有标签
    GetAllClientTags() {
      var t = this;
      t.$http
        .get("/Channel/GetAllClientTags", {}, 2)
        .then((res) => {
          var usertabs = [];
          if (res.resultState == 1) {
            usertabs = res.Data;
          }
          t.userTabs.datas = usertabs;
        })
        .catch((error) => {});
    },
    //保存数据
    async SubData(callback) {
      var t = this;
      if (!t.loading_sub) {
        var params = JSON.parse(JSON.stringify(t.dis));
        console.log("SubData params", params);
        if (!t.useuser.seldatas || t.useuser.seldatas.length <= 0) {
          Toast("请选择指定使用人");
          return;
        }
        if (params.auto_sayhi) {
          if (params.hi_content.sendtype && params.hi_content.sendtype == 1) {
            
          } else {
            var hi_content = params.hi_content;
            // console.log("t.hi_content_tab", t.hi_content_tab);
            // console.log("hi_content", hi_content);
            hi_content.text.content = encodeURIComponent(
              hi_content.text.content || ""
            );
            //数据处理
            switch (t.hi_content_tab) {
              case "a":
                if (
                  !hi_content.text ||
                  !hi_content.text.content ||
                  hi_content.text.content.length <= 0
                ) {
                  Toast("请输入回复内容");
                  return;
                }
                params.hi_content = {
                  text: hi_content.text,
                };
                console.log("hi_content.text", params.hi_content);
                break;
              case "b":
                // if (!hi_content.text || hi_content.text.length <= 0) {
                //   Toast("请输入回复内容");
                //   return;
                // }
                if (t.image_vant.length <= 0) {
                  Toast("请上传图片");
                  return;
                }
                if (t.image_vant[0].status == "uploading") {
                  Toast("图片正在上传，请稍后");
                  return;
                }
                if (t.image_vant[0].status == "failed") {
                  Toast("图片上传失败，请删除重新上传");
                  return;
                }
                if (!t.image_vant[0].path || t.image_vant[0].path.length <= 0) {
                  Toast("请上传图片");
                  return;
                }
                hi_content.image = {
                  media_path: t.image_vant[0].path,
                };
                params.hi_content = {
                  text: hi_content.text,
                  image: hi_content.image,
                };
                break;
              case "d":
                var firmVersion = await t.GetFirmVersionAsync();
                if (firmVersion == "基础版") {
                  t.$AskBuy("基础版无法使用该模块，请先升级您的版本");
                  return;
                }
                if (!t.posterupload_result) {
                  Toast("您还没有上传海报");
                  return;
                }
                params.hi_content = {
                  text: hi_content.text,
                  poster: t.posterupload_result,
                };

                break;
              default:
                if (!hi_content.link) {
                  Toast("请设置图文回复内容");
                  return;
                }
                if (
                  !hi_content.link.title ||
                  hi_content.link.title.length <= 0
                ) {
                  Toast("请输入图文链接标题");
                  return;
                }
                if (!hi_content.link.desc || hi_content.link.title.desc <= 0) {
                  Toast("请输入图文链接描述");
                  return;
                }
                if (!hi_content.link.url || hi_content.link.url.length <= 0) {
                  Toast("请输入图文链接地址");
                  return;
                }
                if (!/^https{0,1}:\/\//i.test(hi_content.link.url)) {
                  Toast("链接地址必须是以http://或https://开头");
                  return;
                }
                if (t.link_vant.length <= 0) {
                  Toast("请上传图片");
                  return;
                }
                if (t.link_vant[0].status == "uploading") {
                  Toast("图片正在上传，请稍后");
                  return;
                }
                if (t.link_vant[0].status == "failed") {
                  Toast("图片上传失败，请删除重新上传");
                  return;
                }
                if (!t.link_vant[0].path || t.link_vant[0].path.length <= 0) {
                  Toast("请上传图片");
                  return;
                }
                hi_content.link.picurl = t.link_vant[0].path;
                hi_content.link.desc = encodeURIComponent(
                  hi_content.link.desc || ""
                );
                hi_content.link.title = encodeURIComponent(
                  hi_content.link.title || ""
                );
                params.hi_content = {
                  text: hi_content.text,
                  link: hi_content.link,
                };
                break;
            }
          }
        } else params.hi_content = {};

        params.useuser = JSON.stringify(t.useuser.seldatas);
        params.tab_content = JSON.stringify(t.userTabs.seltag);
        params.hi_content = JSON.stringify(params.hi_content);
        params.isdefault = t.isdefault;
        params.channeltype = t.channeltype;
        t.loading_sub = true;
        t.$http
          .post("/Channel/SaveChannel", params, 2)
          .then((res) => {
            t.loading_sub = false;
            if (res.resultState == 1) {
              t.dis.channelid = res.Data;
              if (typeof callback == "function") callback();
              else this.$router.back(-1);
            } else {
              Toast(res.errorMsg);
              if (res.Data) t.dis.channelid = res.Data;
            }
          })
          .catch((error) => {
            t.loading_sub = false;
            Toast("网络异常，请稍后重试");
          });
      }
    },
    //
    DownLoadQrCode() {
      var t = this;
      t.SubData(() => {
        t.$router.push({
          path: "/qrcode",
          query: { id: t.dis.channelid },
        });
      });
    },

    ...mapActions(["getFirmInfoAsync", "GetFirmVersionAsync"]),
  },
  components: { wx_tags, wx_users, wx_usersn, hitext, wx_poster },
  computed: {
    ...mapState(["firminfo"]),
    ...mapGetters(["firmversion"]),
    getTabName() {
      var t = this;
      var ret = "";
      for (let i = 0; i < t.userTabs.seltag.length; i++) {
        for (let j = 0; j < t.userTabs.datas.length; j++) {
          for (let s = 0; s < t.userTabs.datas[j].tag.length; s++) {
            if (t.userTabs.datas[j].tag[s].id == t.userTabs.seltag[i]) {
              ret += `[${t.userTabs.datas[j].group_name}]${
                t.userTabs.datas[j].tag[s].name
              }`;
              break;
            }
          }
        }
        if (i < t.userTabs.seltag.length - 1) ret += "，";
      }
      return ret;
    },
    getUserName() {
      var t = this;
      var ret = "";
      if (t.useuser.seldatas) {
        for (let i = 0; i < t.useuser.seldatas.length; i++) {
          var userinfo = t.useuser.datas.find(
            (item) => item.userid == t.useuser.seldatas[i]
          );
          console.log("userinfo", userinfo);
          if (userinfo) ret += userinfo.name;
          if (i < t.useuser.seldatas.length - 1) ret += "，";
        }
      }
      return ret;
    },
    //获得字段应该显示的名称
    GetDescInfo() {
      console.log("this.isdefault", this.isdefault);
      var ret = {
        namelable: "渠道名称",
        btnsublable: "保存渠道",
        useuser: "选择指定使用人（可多选）",
        useuserdesc: "注意：若修改使用人需重新获取二维码",
      };
      if (this.isdefault)
        ret = {
          namelable: "标识名称",
          btnsublable: "保存默认回复设置",
          useuser: "选择指定使用人（单选）",
          useuserdesc: "",
        };
      if (this.channeltype && this.channeltype == 1)
        ret = {
          namelable: "活码名片名称",
          btnsublable: "保存活码名片",
          useuser: "选择分配人员",
          useuserdesc: "用户扫码后将随机分配接待",
        };
      return ret;
    },
  },
  created() {
    var t = this;
    t.getFirmInfoAsync();
    console.log("query", t.$route.query);
    if (t.$route.query.id) t.channelid = t.$route.query.id;
    if (t.$route.query.isdefault) t.isdefault = t.$route.query.isdefault;
    if (t.$route.query.type) t.channeltype = t.$route.query.type;
    t.getDeptObj(0);
    t.$http
      .get("/Firm/GetConfig", {}, 2)
      .then((res) => {
        if (res.resultState == 1) {
          if (!res.Data.Secret) {
            Dialog.confirm({
              title: "系统提示",
              message: "未进行开发配置，需要先配置才能正常创建渠道哦~",
              confirmButtonText: "现在去设置",
              cancelButtonText: "一会再去",
            })
              .then(() => {
                console.log("confirm success");
                window.location.href = "./#/?page=corsettle";
              })
              .catch(() => {
                t.GetFollowUserList();
                t.GetChannelDetail();
                t.GetAllClientTags();
              });
          } else {
            t.GetFollowUserList();
            t.GetChannelDetail();
            t.GetAllClientTags();
          }
        } else {
          Toast(res.errorMsg);
          setTimeout(() => {
            t.$router.back(-1);
          }, 2000);
        }
      })
      .catch((error) => {
        console.log("error", error);
        // Toast("网络异常，请刷新后重试");
        // setTimeout(() => {
        //   t.$router.back(-1);
        // }, 2000);
      });
    // t.GetFollowUserList();
    // t.GetChannelDetail();
    // t.GetAllClientTags();
    t.userTabs.confimEvent = function() {
      t.userTabs_sel = false;
    };
    t.useuser.closeModal = function() {
      t.useuser_sel = false;
    };
  },
  mounted() {},
};
</script>

<style scoped lang="scss" src="../../static/scss/disdetail.scss"></style>
<!-- Add "scoped" attribute to limit CSS to this component only <style scoped  lang="scss" src="../../static/scss/shareindex.scss"></style>-->
